import { gql } from '@apollo/client'

export const MUTATION_UPDATE_USER = gql`
  mutation mutationUpdateUser($input: UpdateUserInput!) {
    updateUser(input: $input) {
      id
    }
  }
`
